module.exports = __webpack_public_path__ + "static/media/Avatars_Female-02.e91a67d0.png";